import api from "../api";

export const uploadCommissionWithExcel = (data) => {
  return api.getApi().post(api.getBaseUrl() + "commissions/uploadExcel", data);
};

export const updateCommissionDetail = (data) => {
  return api
    .getApi()
    .put(
      api.getBaseUrl() +
        `commissions/${data.id}/detail/${data.commissionDetailId}`,
      data
    );
};

export const getErrorCommissions = (id) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + `payments/${id}/commissions/error-commissions`);
};

export const sendCommissionInvoiceMail = (id, mailBodyMessage) => {
  return api
    .getApi()
    .post(api.getBaseUrl() + `commissions/${id}/send-commission-invoice-mail`, {
      mailBodyMessage: mailBodyMessage,
    });
};

export const deleteCommission = (id) => {
  return api.getApi().delete(api.getBaseUrl() + `commissions/${id}`);
};

export const createCommission = (paymentId, data) => {
  return api
    .getApi()
    .post(api.getBaseUrl() + `payments/${paymentId}/commissions`, data);
};

export const getAllInvoicesOperationCommissions = (data) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + `commissions/invoices-operations-commissions`, {
      params: {
        page: data.page,
        pageSize: data.pageSize,
        nameFilter: data.nameFilter,
        emailNameFilter: data.emailNameFilter,
        statusFilter: data.statusFilter,
        countryFilter: data.countryFilter,
        sortColumn: data.sortColumn,
        sortDirection: data.sortDirection,
      },
    });
};

export const syncCommissionWithUser = () => {
  return api
    .getApi()
    .get(api.getBaseUrl() + `commissions/sync-commission-with-user`);
};

export const downloadCommissionExcel = (params) => {
  return api
    .getApi()
    .get(api.getBaseUrl() + `commissions/download-commission-excel`, {
      params,
      responseType: "blob",
    });
};
